module.exports = __webpack_public_path__ + "media/src/images/mypage/btn_add_collection-fda6e132bc883d1838e6bcd99c950eee.png";